// extracted by mini-css-extract-plugin
export default {"wrapper":"search-bar_wrapper__4GIle"};